import React from 'react';
import Footer from '../../../components/Footer/Footer';
import Header from '../../../components/Header/Header';
import './../../../filecard.css';

export default function Edicao1() {
  return (
    <>
      <Header />
      <div className="page-wrap">
        <div className="page-title-wrap">
          <img src="https://i.imgur.com/8n3nyYR.png" />
          <h1>Revista Acadêmica - 1º Edição</h1>
          <img src="https://i.imgur.com/8n3nyYR.png" />
        </div>

        <div className="file-card-container">

          <div className="file-card">
            <h1 className="file-card-title center-text">
               01 - MEDIAÇÃO E ARBITRAGEM </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/01.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">

              02 - A INFLUÊNCIA DA MÍDIA NO TRIBUNAL DO JÚRI </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/02.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">
               03 - PERDÃO JUDICIAL </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/03.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">
               04 - LABELING APROACH</h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/04.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">
               05 - ORTOTANÁSIA </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/05.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">

              06 - SERVIÇO SOCIAL: UMA PROFISSÃO A SERVIÇO DOS DIREITOS, DA
CIDADANIA E JUSTIÇA SOCIAL </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/06.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">
               07 - A REDE DE ATENDIMENTO À
            MULHER VÍTIMA DE VIOLÊNCIA NO MUNÍCIPIO DE ITAMARAJU </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/07.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

          <div className="file-card">
            <h1 className="file-card-title center-text">
               08 - PARTICIPAÇÃO DAS MULHERES NO MST </h1>
            <div className="file-card-divison"></div>
            <a href="/assets/revista/1_edicao/08.pdf"
              className="file-card-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/80/80942.png"
                className="pdf-img"
              />
              <p>Abrir o PDF</p>
            </a>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
}
